import { render, staticRenderFns } from "./ThreeDotsLoader.vue?vue&type=template&id=06fad4e6&scoped=true"
import script from "./ThreeDotsLoader.vue?vue&type=script&lang=ts"
export * from "./ThreeDotsLoader.vue?vue&type=script&lang=ts"
import style0 from "./ThreeDotsLoader.vue?vue&type=style&index=0&id=06fad4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fad4e6",
  null
  
)

export default component.exports